if (!customElements.get('product-detail-countdown')) {
  class ProductDetailCountdown extends HTMLElement {
    connectedCallback() {
      this.daysElement = this.querySelector('[data-countdown-days]');
      this.timeElement = this.querySelector('[data-countdown-time]');
      this.targetTime = this.getTargetTime();

      if (!this.daysElement || !this.timeElement || !Number.isFinite(this.targetTime)) {
        this.hidden = true;
        return;
      }

      this.update();

      if (!this.hidden) {
        this.interval = window.setInterval(() => this.update(), 1000);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    getTargetTime() {
      const year = Number.parseInt(this.dataset.year, 10);
      const month = Number.parseInt(this.dataset.month, 10);
      const day = Number.parseInt(this.dataset.day, 10);
      const hour = Number.parseInt(this.dataset.hour, 10);
      const minute = Number.parseInt(this.dataset.minute, 10);
      const second = Number.parseInt(this.dataset.second || '0', 10);
      const timezone = this.dataset.timezone || '';
      const timezoneMatch = timezone.match(/^([+-])(\d{2}):?(\d{2})$/);

      if (!timezoneMatch) return Number.NaN;

      const dateParts = [year, month, day, hour, minute, second];
      if (dateParts.some((part) => !Number.isInteger(part))) return Number.NaN;

      const validationDate = new Date(Date.UTC(year, month - 1, day, hour, minute, second));
      const isValidDate = validationDate.getUTCFullYear() === year
        && validationDate.getUTCMonth() === month - 1
        && validationDate.getUTCDate() === day
        && validationDate.getUTCHours() === hour
        && validationDate.getUTCMinutes() === minute
        && validationDate.getUTCSeconds() === second;

      if (!isValidDate) return Number.NaN;

      const timezoneDirection = timezoneMatch[1] === '-' ? -1 : 1;
      const timezoneMinutes = timezoneDirection
        * (Number.parseInt(timezoneMatch[2], 10) * 60 + Number.parseInt(timezoneMatch[3], 10));

      return validationDate.getTime() - timezoneMinutes * 60 * 1000;
    }

    update() {
      const remainingSeconds = Math.floor((this.targetTime - Date.now()) / 1000);

      if (remainingSeconds < 0) {
        this.hidden = true;
        this.stop();
        return;
      }

      const days = Math.floor(remainingSeconds / 86400);
      const hours = Math.floor((remainingSeconds % 86400) / 3600);
      const minutes = Math.floor((remainingSeconds % 3600) / 60);
      const seconds = remainingSeconds % 60;

      this.daysElement.textContent = String(days);
      this.timeElement.textContent = [hours, minutes, seconds]
        .map((value) => String(value).padStart(2, '0'))
        .join(':');
      this.hidden = false;
    }

    stop() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }
  }

  customElements.define('product-detail-countdown', ProductDetailCountdown);
}
